import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css';

import React, { useState, useEffect } from 'react';
import { Dropdown, Menu } from 'antd';
import { DownOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons';
import './header.css';
import hcuraLogo from '../../assets/images/hcura-homeopathy-logo.png';
import { Link } from 'react-router-dom';

const treatmentGroups = [
  {
    icon: <i className="fas fa-hat-cowboy text-success"></i>,
    title: "Advanced Hair Treatments",
    items: [
      "PRP Hair Treatment",
      "GFC Hair Treatment",
      "Grow Hair Treatment",
      "STM Hair Treatment",
      "Laser Hair Treatment"
    ],
    links: [
      "/advanced-hair-prp-treatment",
      "/advanced-hair-gfc-treatment",
      "/advanced-grow-hair-treatment",
      "/advanced-stm-treatment",
      "/advanced-laser-treatment"
    ],
    color: "#eafff3"
  },
  {
    icon: <i className="fas fa-spa text-success"></i>,
    title: "Advanced Skin Treatments",
    items: [
      "advanced-acne-treatment",
      "advanced-prp-face-treatment",
      "advanced-acne-scar-treatment",
      "advanced-anti-ageing-treatment",
      "advanced-skin-brightening-treatment",
      "advanced-hydrafacial-treatment",
      "advanced-youth-treatment",
      "advanced-co2-facial-treatment",
      "advanced-acne-scar-treatment",
      "advanced-mole-birth-mark-removal-treatment",
      "advanced-tatto-removal-treatment",
      "advanced-warts-removal-treatment",
      "advanced-anti-ageing-laser-treatment",
      "advanced-laser-hair-removal-treatment"

    ],
    links: [
      "/advanced-acne-treatment",
      "/advanced-prp-face-treatment",
      "/advanced-acne-scar-treatment",
      "/advanced-anti-ageing-treatment",
      "/advanced-skin-brightening-treatment",
      "/advanced-hydrafacial-treatment",
      "/advanced-youth-treatment",
      "/advanced-co2-facial-treatment",
      "/advanced-acne-scar-treatment",
      "/advanced-mole-birth-mark-removal-treatment",
      "/advanced-tatto-removal-treatment",
      "/advanced-warts-removal-treatment",
      "/advanced-anti-ageing-laser-treatment",
      "/advanced-laser-hair-removal-treatment"
    ],
    color: "#f0f9ff"
  },
  {
    icon: <i className="fas fa-leaf text-success"></i>,
    title: "Homeopathy Treatments",
    items: [
      "PCOD Treatment",
      "Thyroid ",
      "Infertility",
      "Eczema",
      "Asthma",
      "Migraine",
      "Anxiety & Stress",
      "Alopecia Areata",
      "Piles"
    ],
    links: [
      "/homeopathy-best-treatments/pcod-pcos-treatment",
      "/homeopathy-best-treatments/thyroid-treatment",
      "/homeopathy-best-treatments/infertility-treatment",
      "/homeopathy-best-treatments/eczema-treatment",
      "/homeopathy-best-treatments/asthma-treatment",
      "/homeopathy-best-treatments/migraine-treatment",
      "/homeopathy-best-treatments/anxiety-neurosis-treatment",
      "/homeopathy-best-treatments/alopecia-areata-treatment",
      "/homeopathy-best-treatments/piles-treatment"
    ],
    color: "#fffbee"
  },
  {
    icon: <i className="fas fa-tooth text-success"></i>,
    title: "Dental Treatments",
    items: [
      "Root Canal Treatment",
      "Tooth Extraction",
      "Dental Implants",
      "Teeth Whitening",
      "Braces & Aligners"
    ],
    links: [
      "/dental-treatment",
      "/dental-treatment",
      "/dental-treatment",
      "/dental-treatment",
      "/dental-treatment"
    ],
    color: "#f1fff2"
  }
];

const aboutMenuItems = [
  { key: "about", label: "About Us", href: "/about/", icon: "fa-info-circle" },
  { key: "doctors", label: "Our Doctors", href: "/doctors-list/", icon: "fa-user-md" },
  { key: "blogs", label: "Blogs", href: "/blog", icon: "fa-blog" },
  { key: "contact", label: "Contact", href: "/contact-us/", icon: "fa-phone" },
];

const clinicsMenuItems = [
  { key: "bangalore", label: "Bangalore", href: "/homeopathy-clinic-in-bangalore/", icon: "fa-map-marker-alt" },
  { key: "chennai", label: "Chennai", href: "/multispecialty-clinic-in-chennai/", icon: "fa-map-marker-alt" },
];

const chennaiLocations = [
  { key: "gerugambakkam", label: "Gerugambakkam", href: "/multispecialty-clinic-in-gerugambakkam-chennai" },
  { key: "valasaravakkam", label: "Valasaravakkam", href: "/multispecialty-clinic-in-valasaravakkam-chennai/" },
  { key: "tambaram", label: "Tambaram", href: "/multispecialty-clinic-in-tambaram-chennai" },
  { key: "navalur", label: "Navalur", href: "/multispecialty-clinic-in-navalur-chennai" },
];

const aboutMenu = (
  <Menu className="hcura__dropdown--about">
    {aboutMenuItems.map(item => (
      <Menu.Item key={item.key}>
        <Link to={item.href}>
          <i className={`fas ${item.icon}`}></i>
          {item.label}
        </Link>
      </Menu.Item>
    ))}
  </Menu>
);

const treatmentsMenu = (
 <Menu className="hcura__dropdown--treatments hcura__treatments--simplified">
<Menu.Item key="hair">
  <Link to="/advanced-hair-prp-treatment">
    Advanced Hair
  </Link>
</Menu.Item>
<Menu.Item key="skin">
  <Link to="/advanced-hydrafacial-treatment">
    Advanced Skin
  </Link>
</Menu.Item>

    <Menu.Item key="homeopathy">
      <Link to="/homeopathy-best-treatments/">
        Advanced Homeopathy
      </Link>
    </Menu.Item>
    <Menu.Item key="dental">
      <Link to="/dental-treatment">
        Advanced Dental
      </Link>
    </Menu.Item>
  </Menu>

);

// Chennai Submenu
const chennaiSubmenu = (
  <Menu className="hcura__dropdown--clinics">
    {chennaiLocations.map(location => (
      <Menu.Item key={location.key}>
        <Link to={location.href}>
          <i className="fas fa-map-marker-alt"></i>
          {location.label}
        </Link>
      </Menu.Item>
    ))}
  </Menu>
);

// Our Clinics Dropdown (Desktop)
const clinicsMenu = (
  <Menu className="hcura__dropdown--clinics">
    <Menu.Item key="bangalore">
      <Link to="/homeopathy-clinic-in-bangalore/">
        <i className="fas fa-map-marker-alt"></i>
        Bangalore
      </Link>
    </Menu.Item>
 
    <Menu.Item key="chennai">
      <Dropdown overlay={chennaiSubmenu} trigger={['hover']} placement="rightTop">
        <Link to="/multispecialty-clinic-in-chennai/" onClick={e => e.preventDefault()}>
          <i className="fas fa-map-marker-alt"></i>
          Chennai
        </Link>
      </Dropdown>
    </Menu.Item>
  </Menu>
);

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showSheet, setShowSheet] = useState(false);
  const [showAboutMobileDropdown, setShowAboutMobileDropdown] = useState(false);
  const [showClinicsMobileDropdown, setShowClinicsMobileDropdown] = useState(false);
  const [showChennaiMobileDropdown, setShowChennaiMobileDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const closeMobile = () => {
    setMobileOpen(false);
    setShowSheet(false);
    setShowAboutMobileDropdown(false);
    setShowClinicsMobileDropdown(false);
    setShowChennaiMobileDropdown(false);
  };

  const closeSheet = () => {
    setShowSheet(false);
  };

  

  return (
    <>
      <header className={`hcura__header--primary ${scrolled ? 'hcura__header--scrolled' : ''}`}>
        <div className="hcura__locations--scrollbar">
          <div className="hcura__locations--track-wrapper">
            <div className="hcura__locations--content-block">
              <span className="hcura__location--single-item"><i className="fas fa-map-marker-alt"></i> Bangalore - Jayanagar</span>
              <span className="hcura__location--divider">|</span>
              <span className="hcura__location--single-item"><i className="fas fa-map-marker-alt"></i> Pondicherry - Vallar Nagar</span>
              <span className="hcura__location--divider">|</span>
              <span className="hcura__location--single-item"><i className="fas fa-map-marker-alt"></i> Chennai - Valasaravakkam, Gerugambakkam, Tambaram, Navalur, Kodambakkam</span>
              <span className="hcura__location--divider">|</span>
            </div>
            <div className="hcura__locations--content-block">
              <span className="hcura__location--single-item"><i className="fas fa-map-marker-alt"></i> Bangalore - Jayanagar</span>
              <span className="hcura__location--divider">|</span>
              <span className="hcura__location--single-item"><i className="fas fa-map-marker-alt"></i> Pondicherry - Vallar Nagar</span>
              <span className="hcura__location--divider">|</span>
              <span className="hcura__location--single-item"><i className="fas fa-map-marker-alt"></i> Chennai - Valasaravakkam, Gerugambakkam,  Tambaram, Navalur, Kodambakkam</span>
              <span className="hcura__location--divider">|</span>
            </div>
          </div>
        </div>

        <nav className="hcura__navbar--main-navigation">
          <div className="container-fluid">
            <div className="hcura__navbar--content-wrapper">
              <Link to="/" className="hcura__brand--logo-link" onClick={closeMobile}>
                <img src={hcuraLogo} alt="H-Cura" />
              </Link>

              <ul className="hcura__navlinks--desktop-menu hcura__display--desktop-only">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="hcura__navitem--has-dropdown">
                  <Dropdown overlay={aboutMenu} trigger={['hover']} placement="bottomCenter">
                    <Link to="/about/" onClick={e => e.preventDefault()}>
                      About <DownOutlined />
                    </Link>
                  </Dropdown>
                </li>
                <li className="hcura__navitem--has-dropdown">
                  <Dropdown overlay={treatmentsMenu} trigger={['hover']} placement="bottomCenter">
                    <Link to="/alltreatments" onClick={e => e.preventDefault()}>
                      Treatments <DownOutlined />
                    </Link>
                  </Dropdown>
                </li>
                <li className="hcura__navitem--has-dropdown">
                  <Dropdown overlay={clinicsMenu} trigger={['hover']} placement="bottomCenter">
                    <Link to="/homeopathy-clinic-in-bangalore/" onClick={e => e.preventDefault()}>
                      Our Clinics <DownOutlined />
                    </Link>
                  </Dropdown>
                </li>
                <li>
                  <Link to="/homeopathy-online-consultation/">Online Consultation</Link>
                </li>
                <li>
                  <Link to="/homeopathy-corporate-camps/">Corporate</Link>
                </li>
              </ul>

              <Link to="/bookconsultation" className="hcura__cta--appointment-button hcura__display--desktop-only" onClick={closeMobile}>
                Book Free Appointment
              </Link>

              <button className="hcura__toggle--mobile-menu" onClick={() => setMobileOpen(!mobileOpen)}>
                {mobileOpen ? <CloseOutlined /> : <MenuOutlined />}
              </button>
            </div>
          </div>
        </nav>

        {isMobile && mobileOpen && (
          <div className="hcura__mobile--menu-overlay">
            <div className="hcura__mobile--menu-content">
              <ul className="hcura__mobile--navigation-menu">
                <li className="hcura__mobile--nav-item">
                  <Link to="/" className="hcura__mobile--nav-link" onClick={closeMobile}>
                    <span className="hcura__mobile--link-content">
                      <i className="fas fa-home hcura__mobile--link-icon"></i>
                      Home
                    </span>
                  </Link>
                </li>
                <li className="hcura__mobile--nav-item">
                  <button
                    className="hcura__mobile--nav-link"
                    onClick={() => setShowAboutMobileDropdown(!showAboutMobileDropdown)}
                  >
                    <span className="hcura__mobile--link-content">
                      <i className="fas fa-info-circle hcura__mobile--link-icon"></i>
                      About Us
                    </span>
                    <DownOutlined rotate={showAboutMobileDropdown ? 180 : 0} />
                  </button>
                  <div className={`hcura__mobile--submenu ${showAboutMobileDropdown ? 'hcura__mobile--submenu-visible' : ''}`}>
                    <ul>
                      {aboutMenuItems.map(item => (
                        <li key={item.key}>
                          <Link to={item.href} onClick={closeMobile}>
                            <i className={`fas ${item.icon}`}></i>
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  </li>
                <li className="hcura__mobile--nav-item">
                  <button
                    className="hcura__mobile--nav-link"
                    onClick={() => setShowSheet(true)}
                  >
                    <span className="hcura__mobile--link-content">
                      <i className="fas fa-th-large hcura__mobile--link-icon"></i>
                      All Treatments
                    </span>
                                        <DownOutlined rotate={showAboutMobileDropdown ? 180 : 0} />

                  </button>
                </li>
                <li className="hcura__mobile--nav-item">
                  <button
                    className="hcura__mobile--nav-link"
                    onClick={() => setShowClinicsMobileDropdown(!showClinicsMobileDropdown)}
                    >
                    <span className="hcura__mobile--link-content">
                      <i className="fas fa-hospital hcura__mobile--link-icon"></i>
                      Our Clinics
                    </span>
                    <DownOutlined rotate={showClinicsMobileDropdown ? 180 : 0} />
                  </button>
                  <div className={`hcura__mobile--submenu ${showClinicsMobileDropdown ? 'hcura__mobile--submenu-visible' : ''}`}>
                    <ul>
                      <li>
                        <Link to="/homeopathy-clinic-in-bangalore/" onClick={closeMobile}>
                          <i className="fas fa-map-marker-alt"></i>
                          Bangalore
                        </Link>
                      </li>
                      <li>
                        <button
                          className="hcura__mobile--nav-link"
                          onClick={() => setShowChennaiMobileDropdown(!showChennaiMobileDropdown)}
                        >
                          <span className="hcura__mobile--link-content">
                            <i className="fas fa-map-marker-alt"></i>
                            Chennai
                          </span>
                          <DownOutlined rotate={showChennaiMobileDropdown ? 180 : 0} />
                        </button>
                        <div className={`hcura__mobile--submenu ${showChennaiMobileDropdown ? 'hcura__mobile--submenu-visible' : ''}`}>
                          <ul>
                            {chennaiLocations.map(location => (
                              <li key={location.key}>
                                <Link to={location.href} onClick={closeMobile}>
                                  <i className="fas fa-map-marker-alt"></i>
                                  {location.label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="hcura__mobile--nav-item">
                  <Link to="/homeopathy-online-consultation/" className="hcura__mobile--nav-link" onClick={closeMobile}>
                    <span className="hcura__mobile--link-content">
                      <i className="fas fa-video hcura__mobile--link-icon"></i>
                      Online Consultation
                    </span>
                  </Link>
                </li>
                <li className="hcura__mobile--nav-item">
                  <Link to="/homeopathy-corporate-camps/" className="hcura__mobile--nav-link" onClick={closeMobile}>
                    <span className="hcura__mobile--link-content">
                      <i className="fas fa-building hcura__mobile--link-icon"></i>
                      Corporate
                    </span>
                  </Link>
                </li>
                <li className="hcura__mobile--nav-item">
                  <Link to="/bookconsultation" className="hcura__mobile--appointment-cta" onClick={closeMobile}>
                    <i className="fas fa-calendar-check"></i>
                    Book Appointment
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        )}
      </header>

      <div className="hcura__header--spacer"></div>

      {isMobile && showSheet && (
        <>
          <div className="hcura__sheet--backdrop" onClick={closeSheet}></div>
          <div className="hcura__treatment--drawer-panel">
            <div className="hcura__drawer--handle-bar"></div>
            <button className="hcura__drawer--close-button" onClick={closeSheet} aria-label="Close">
              <CloseOutlined />
            </button>
            <h5 className="hcura__drawer--panel-title">All Treatments</h5>
            <div className="hcura__drawer--body-content">
              {treatmentGroups.map((group) => (
                <div key={group.title} className="hcura__treatment--group-section">
                  <div className="hcura__group--card-container" style={{background: group.color}}>
                    <div className="hcura__group--header-section">
                      <span className="hcura__group--icon-wrapper">{group.icon}</span>
                      <span className="hcura__group--title-text">{group.title}</span>
                    </div>
                    <ul className="hcura__group--items-list">
                      {group.items.map((item, i) => (
                        <li key={i}>
                          <Link to={group.links[i]} className="hcura__group--item-link" onClick={closeMobile}>
                            {item}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;


